import {
  getCore as get,
  postCore as post,
  putCore as put,
  delCore as del,
} from "../../utils/httpInterceptor";

class TenantService {
  static async getAll(page, size, filters) {
    const queryParams = new URLSearchParams({
      page,
      size,
      // Compat: el backend antiguo usaba (code/name/enabled)
      // El backend IDAX actual usa (code/name/status) en la entidad,
      // pero mantenemos estos params para no romper el controlador actual.
      code: filters.code || filters.code || "",
      name: filters.name || filters.name || "",
      enabled:
        filters.enabled !== undefined
          ? filters.enabled
          : filters.status
            ? String(filters.status).toLowerCase() === "active"
            : "",
    }).toString();

    const response = await get(`/api/tenants/paginado?${queryParams}`);

    // Normalizar respuesta para UI: code/name/status/enabled
    if (response && response.content) {
      response.content = response.content.map((tenant) => {
        const code = tenant.code ?? tenant.code;
        const name = tenant.name ?? tenant.name;
        const status = tenant.status ?? (tenant.activo ? "active" : "disabled");
        const enabled =
          tenant.enabled ??
          tenant.activo ??
          (typeof status === "string" && status.toLowerCase() === "active");

        return {
          ...tenant,
          code,
          name,
          status,
          enabled,
        };
      });
    }

    return response;
  }

  static async createTenant(newTenant) {
    const payload = {
      ...newTenant,
      code: newTenant.code ?? newTenant.code,
      name: newTenant.name ?? newTenant.name,
      status: newTenant.status ?? (newTenant.enabled ? "active" : "disabled"),
    };
    return await post("/api/tenants", payload);
  }

  static async updateTenant(tenantId, updatedTenant) {
    const payload = {
      ...updatedTenant,
      code: updatedTenant.code ?? updatedTenant.code,
      name: updatedTenant.name ?? updatedTenant.name,
      status:
        updatedTenant.status ??
        (updatedTenant.enabled !== undefined
          ? updatedTenant.enabled
            ? "active"
            : "disabled"
          : undefined),
    };
    return await put(`/api/tenants/${tenantId}`, payload);
  }

  static async deleteTenant(tenantId) {
    return await del(`/api/tenants/${tenantId}`);
  }

  static async updateEnabled(tenantId, updatedTenant) {
    const status = updatedTenant.enabled ? "active" : "disabled";
    return await put(`/api/tenants/enabled/${tenantId}`, { status });
  }

  // Alias para compatibilidad con CrudManager
  static async create(newTenant) {
    return this.createTenant(newTenant);
  }

  static async update(tenantId, updatedTenant) {
    return this.updateTenant(tenantId, updatedTenant);
  }

  static async delete(tenantId) {
    return this.deleteTenant(tenantId);
  }
}

export default TenantService;
